/**
 * Page router. Toggles the `.active` class on `.page`/`.nav-item` elements and
 * runs per-page enter hooks (registered by main.ts to avoid import cycles).
 * Faithful to the monolith's showPage/goBack behaviour.
 */

import { $$, byId } from './dom';
import { navIdFor, renderSectionTabs } from './section-tabs';

const enterHooks: Record<string, () => void> = {};
const leaveHooks: Record<string, () => void> = {};
const history: string[] = [];
let currentPage = '';

/** Register a callback to run when a page is entered. */
export function onPageEnter(id: string, fn: () => void): void {
  enterHooks[id] = fn;
}

/** Register a callback to run when a page is left (e.g. to release a camera). */
export function onPageLeave(id: string, fn: () => void): void {
  leaveHooks[id] = fn;
}

export function currentPageId(): string {
  return currentPage;
}

export function showPage(id: string, pushHistory = true): void {
  if (currentPage && currentPage !== id) {
    leaveHooks[currentPage]?.();
  }
  if (pushHistory !== false && currentPage && currentPage !== id) {
    history.push(currentPage);
  }
  for (const page of $$('.page')) page.classList.remove('active');
  byId('page-' + id)?.classList.add('active');
  for (const nav of $$('.nav-item')) nav.classList.remove('active');
  // Several pages share one bottom-nav destination (panel+vd, legal+law), so
  // the highlighted item is looked up rather than derived from the page id.
  byId('nav-' + navIdFor(id))?.classList.add('active');
  renderSectionTabs(id);
  currentPage = id;

  const back = byId('btn-back');
  if (back) back.style.display = history.length > 0 ? 'flex' : 'none';

  enterHooks[id]?.();
}

export function goBack(): void {
  if (!history.length) return;
  const prev = history.pop() as string;
  showPage(prev, false);
}
